const getVideoDuration = async (f: File): Promise<{ duration: number; width: number; height: number }> => {
  const fileCallbackToPromise = (fileObj: HTMLVideoElement) => {
    return Promise.race([
      new Promise((resolve) => {
        if (fileObj instanceof HTMLImageElement) fileObj.onload = resolve;
        else fileObj.onloadedmetadata = resolve;
      }),
      new Promise((resolve) => {
        setTimeout(resolve, 1000);
      }),
    ]);
  };

  const objectUrl = URL.createObjectURL(f);
  // const isVideo = type.startsWith('video/');
  const video = document.createElement('video');
  video.src = objectUrl;
  await fileCallbackToPromise(video);
  return {
    duration: video.duration,
    width: video.videoWidth,
    height: video.videoHeight,
  };
};

export default getVideoDuration;
